module.exports = "https://static.wagwalking.com/_next/static/images/maxbone-1a-ebcccd40d90e8fc716d4477f4a0076b9.png";